import { render, staticRenderFns } from "./Train.vue?vue&type=template&id=49981427&scoped=true&"
import script from "./Train.vue?vue&type=script&lang=js&"
export * from "./Train.vue?vue&type=script&lang=js&"
import style0 from "./style.less?vue&type=style&index=0&id=49981427&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49981427",
  null
  
)

export default component.exports